<template>
  <Layout id="app">
    <router-view />
  </Layout>
</template>

<script>
import Layout from './views/layouts/layouts.vue'

import { mapGetters, mapMutations } from 'vuex'

// TODO: Get config from Fauna, not config files...
import { townName } from './config/general'
import { layers as layerConfig } from 'config/mapbox'
import { planMode } from '@/config/mapbox'

export default {
  name: 'App',
  components: {
    Layout
  },
  computed: {
    ...mapGetters('config', {
      townName: 'name'
    }),
    ...mapGetters('filters', [
      'getActiveMunicipality',
      'getActiveNeighborhood',
      'getAllFilterInfo'
    ]),
    ...mapGetters('map', [
      'getFilterStatus'
    ])
  },
  created() {
    this.loadConfig()
    this.setTitle({ title: 'Platform31 Wijkprofielen' })

    /**
     * Restore the filter settings from localstorage
     */
    let filters = localStorage.getItem('p31-filters')
    if (filters) {
      this.restoreFilterSettings({ activeIds: filters.split(',') })
    }
    /**
     * Restore active barcode components
     */
    let components = localStorage.getItem('p31-barcode')
    if (components) {
      this.restoreActiveComponents({ components })
    }
    /**
     * Restore the municipality and neighborhood setting from localstorage
     */
    let municipality = localStorage.getItem('p31-municipality')
    if (municipality) {
      this.setMunicipality({ municipality })
    }
    let neighborhood = localStorage.getItem('p31-neighborhood')
    if (neighborhood) {
      this.setNeighborhood({ neighborhood })
    }
    /**
     * Restore filterStatus (e.g. displaymode) from localstorage
     */
    let filterStatus = localStorage.getItem('p31-filter-status')
    if (filterStatus) {
      this.updateFilterStatus(JSON.parse(filterStatus))
    }
  },
  watch: {
    '$route' (to) {
      this.setTitle({ title: to.meta.title || 'Platform31 Wijkprofielen' })
    },
    /**
     * Whenever the municipality or neighborhood changes, store it in localstorage
     */
    getActiveMunicipality(value) {
      localStorage.setItem('p31-municipality', value)
    },
    getActiveNeighborhood(value) {
      localStorage.setItem('p31-neighborhood', value)
    },
    /**
     * Whenever the filter settings change, store the ids of the active filters as an array in localstorage.
     */
    getAllFilterInfo: {
      handler(value) {
        delete value.bouwblok
        delete value['bouwblok-auto']

        let result = Object.values(value).map(filter => 
          filter.items.filter(item => item.active).map(item => item.id)
        ).reduce((result, filter) => {
          filter.forEach(item => result.push(item))
          return result
        }, [])

        localStorage.setItem('p31-filters', result)

        result = Object.values(value).filter(filter => filter.component && filter.enabled).map(filter => filter.id)
        localStorage.setItem('p31-barcode', result)
      },
      deep: true
    },
    /**
     * Store any change to a filterStatus in localstorage
     */
    getFilterStatus: {
      handler(value) {
        localStorage.setItem('p31-filter-status', JSON.stringify(value))
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations('config', [
      'setConfig'
    ]),
    ...mapMutations('filters', [
      'restoreFilterSettings',
      'restoreActiveComponents',
      'setMunicipality',
      'setNeighborhood'
    ]),
    ...mapMutations('map', [
      'updateFilterStatus'
    ]),
    setTitle({ title }) {
      if (this.townName) {
        title = title + ' - ' + this.townName
      }
      document.title = title
    },
    loadConfig() {
      this.setConfig({
        name: townName,
        layers: layerConfig[process.env.VUE_APP_MUNICIPALITY],
        planmode: planMode
      })
    }
  }
}
</script>


<style lang="scss">

html, body {
  height: 100%;
  font-family: 'Gibson' !important;
  font-size: 14px;
}
html {
  overflow-y: hidden;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
}

/** Tippy Tooltip - style overrides */
.tippy-tooltip {
  text-align: left;
  font-size: 1rem;
}

</style>
